import { ReactNode, useMemo, useState } from 'react';
import { Nullable } from '../../utilities/common_types';
import { PreferredLanguageContext } from './preferred_language_context';

interface PreferredLanguageContextProviderProps {
  readonly children: ReactNode;
}
export function PreferredLanguageContextProvider({
  children,
}: PreferredLanguageContextProviderProps) {
  const [language, setLanguage] = useState<Nullable<string>>(null);

  const contextValue = useMemo(() => ({ language, setLanguage }), [language, setLanguage]);
  return (
    <PreferredLanguageContext.Provider value={contextValue}>
      {children}
    </PreferredLanguageContext.Provider>
  );
}
